<template>
  <section class="cart account">
    <router-link :to="{ name: 'shop' }" class="btn btn--tertiary cart__shop-link"
      >Back to shop</router-link
    >
    <div class="cart__shop">
      <div class="cart__main account__cart-list">
        <ShoppingCartList />
      </div>
      <div v-if="showShoppingCartResume" class="account__cart-list--mobile">
        <ShoppingCartResume />
      </div>
      <div :class="['cart__aside account__aside', isAccountPage && 'cart__aside--account']">
        <div class="account__title-wrapper">
          <h4 class="account__title">Sign in or sign up to continue</h4>
          <AccountSignInUp />
        </div>
      </div>
    </div>
    <SmallPrints flow-styles />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ShoppingCartList from '@/components/cart/ShoppingCartList.vue'
import ShoppingCartResume from '@/components/cart/ShoppingCartResume.vue'
import AccountSignInUp from '@/components/login/AccountSignInUp.vue'
import { routesRules } from '@/helpers/mixins'
import SmallPrints from '@/components/flow/small-prints/SmallPrints.vue'
import CONSTANTS from '@/constants'

const { MOBILE, TABLET } = CONSTANTS.BREAKPOINTS
export default {
  name: 'Account',
  mixins: [routesRules],
  components: {
    ShoppingCartList,
    AccountSignInUp,
    ShoppingCartResume,
    SmallPrints,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isMobile: false,
      isTablet: false,
    }
  },
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
    }),
    showShoppingCartResume() {
      return this.isMobile || this.isTablet
    },
  },
  watch: {
    shoppingCart: {
      immediate: true,
      handler(items) {
        if (items.length === 0) {
          this.$router.push({ name: 'shop' })
        }
      },
    },
    windowWidth() {
      this.setLayout()
    },
  },
  methods: {
    setLayout() {
      this.isMobile = window.innerWidth <= MOBILE
      this.isTablet = window.innerWidth <= TABLET
    },
  },
  mounted() {
    this.setLayout()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
}
</script>

<style lang="scss">
.account {
  max-width: 1200px;
  padding: 0 20px;
  margin-bottom: 160px;
  @include mobile {
    padding: 0 25px;
    width: 100%;
    margin-bottom: unset;
  }
  @include tablet-ipad-air-and-mini-portrait {
    margin-bottom: 160px;
  }
  @include desktop {
    margin-bottom: 160px;
  }
  &__title {
    font-family: var(--font-regular);
    font-weight: 450;
    font-size: rem(24px);
    line-height: 32px;
    color: var(--white);
    margin: 0;
    margin-bottom: 20px;
    @include tablet {
      margin: 30px 0;
    }
    text-align: center;
  }
  .cart__shop {
    margin: 45px 0 0 0;
    background: none;
    @include tablet {
      margin: 25px 0 0 0;
      background: var(--black-2);
    }
  }
  &__cart-list {
    display: none;
    &--mobile {
      display: block;
      margin-bottom: 20px;
      width: 100%;
    }
    @include tablet {
      display: block;
      &--mobile {
        display: none;
      }
    }
  }
  &__aside {
    background: var(--mid-gray-gradient);
    border-radius: 25px;
    padding: 40px 20px;
    @include mobile {
      padding: 40px 70px;
    }
  }
}
</style>
